import axios from 'axios';
import { interceptorOnResponseError, interceptorOnResponse } from '../utils/axios-token-interceptor';
import { useClientStore } from '@@/stores/client';

export default defineNuxtPlugin(() => {
  return {
    provide: {
      clients: new Clients(),
    },
  };
});

class Clients {
  clients: Record<string, ReturnType<typeof axios.create>>;

  constructor() {
    this.clients = {};
  }

  getClient(clientName: string) {
    this.initializeClients();
    return this.clients[clientName];
  }

  initializeClients() {
    const clientStore = useClientStore();
    const mediaSub = clientStore.mediaSubscription;
    if (!this.clients.media && mediaSub) {
      this.clients.media = axios.create({
        baseURL: `${mediaSub.apiUrl}/api/v4`,
        headers: {
          Authorization: this.getToken('media'),
        },
      });
    }
    if (!this.clients.analytics && mediaSub) {
      this.clients.analytics = axios.create({
        baseURL: `${mediaSub.apiUrl}`,
        headers: {
          Authorization: this.getToken('media'),
        },
      });
    }
    const roomsSub = clientStore.roomsSubscription;
    if (!this.clients.rooms && roomsSub) {
      this.clients.rooms = axios.create({
        baseURL: `${roomsSub.apiUrl}`,
        headers: {
          Authorization: this.getToken(),
        },
      });
    }
    const engageSub = clientStore.engageSubscription;
    if (!this.clients.engage && engageSub) {
      this.clients.engage = axios.create({
        baseURL: `${engageSub.apiUrl}`,
        headers: {
          Authorization: this.getToken(),
        },
      });
    }
    const attendanceProSub = clientStore.attendanceProSubscription;
    if (!this.clients.attendancePro && attendanceProSub) {
      this.clients.attendancePro = axios.create({
        baseURL: `${attendanceProSub.apiUrl}/admin-api`,
        headers: {
          Authorization: this.getToken(),
        },
      });
    }

    Object.keys(this.clients).forEach((client) => {
      const axios_client = this.clients[client];
      axios_client.interceptors.response.use(interceptorOnResponse(), interceptorOnResponseError(axios_client));
    });
  }

  getToken(app?: string) {
    let token = `Bearer ${useAuth().idToken.value}`;
    if (app === 'media') {
      token = token.replace('Bearer', 'Openid');
    }
    return token;
  }
}
